import type { CtaLocation, MarketId, StrategyId } from '../analytics/events'
import { trackPublicEvent } from '../analytics/posthog'
import { trackMetaCompleteRegistration, trackMetaLead } from '../analytics/meta-pixel'

/** Safe click handlers for public CTAs — never attach button text as a property. */
export function trackOpenAccount(cta_location: CtaLocation) {
  trackPublicEvent('open_account_clicked', { cta_location })
  trackMetaLead({ cta_location })
  trackMetaCompleteRegistration({ cta_location })
}

export function trackClientLogin(cta_location: CtaLocation) {
  trackPublicEvent('client_login_clicked', { cta_location })
}

export function trackSupport(cta_location: CtaLocation) {
  trackPublicEvent('support_clicked', { cta_location })
}

export function trackContact(cta_location: CtaLocation) {
  trackPublicEvent('contact_clicked', { cta_location })
}

export function trackStrategySelected(strategy: StrategyId, cta_location: CtaLocation = 'strategy_section') {
  trackPublicEvent('strategy_selected', { strategy, cta_location })
}

export function trackStrategyViewed(strategy: StrategyId, cta_location: CtaLocation = 'strategy_section') {
  trackPublicEvent('strategy_viewed', { strategy, cta_location })
}

export function trackMarketSelected(market: MarketId, cta_location: CtaLocation = 'hero') {
  trackPublicEvent('market_selected', { market, cta_location })
}

export function trackRiskDisclosure(cta_location: CtaLocation = 'legal') {
  trackPublicEvent('risk_disclosure_opened', { cta_location })
}

export function trackLandingView() {
  trackPublicEvent('landing_view', { cta_location: 'trade_landing' })
}

export function trackCreateAccountFocus(cta_location: CtaLocation = 'hero') {
  trackPublicEvent('create_account_focus', { cta_location })
}

export function trackCreateAccountSubmit(cta_location: CtaLocation = 'hero') {
  trackPublicEvent('create_account_submit', { cta_location })
}

export function trackCreateAccountSuccess(cta_location: CtaLocation = 'hero') {
  trackPublicEvent('create_account_success', { cta_location })
}

/** Never attach API messages, emails, or field values. */
export function trackCreateAccountError(cta_location: CtaLocation = 'hero') {
  trackPublicEvent('create_account_error', { cta_location })
}

export function trackExplainerPlay(cta_location: CtaLocation = 'trade_landing') {
  trackPublicEvent('explainer_play', { cta_location })
}

export function trackThemeChanged(ui_theme: 'light' | 'dark') {
  trackPublicEvent('theme_changed', { cta_location: 'header', ui_theme })
}

export function trackSignInClicked(cta_location: CtaLocation) {
  trackPublicEvent('sign_in_clicked', { cta_location })
  trackClientLogin(cta_location)
}

export function trackRiskDisclosureClicked(cta_location: CtaLocation = 'nav') {
  trackPublicEvent('risk_disclosure_clicked', { cta_location })
  trackRiskDisclosure(cta_location)
}
